<template>
  <span v-if="hasSchedule" v-html="longForm"></span>
</template>

<script>
// Constants
import constants from '@/constants';

/*
Note: The template and logic for this component has been simplified to only display the hours of operation in the
longForm. The pretty-schedule component in IQ contains template and logic code to display a longForm and shortForm
based on screen size.
*/
export default {
  name: 'pretty-schedule',
  props: {
    schedule: String
  },
  computed: {
    longForm() {
      if (this.hasSchedule && this.shouldParse) {
        return this.createSchedule(this.parsedInput).long;
      }

      return this.isPreformatted ? this.schedule.slice(1) : this.schedule;
    }
  },
  data() {
    let parsedInput = constants.prettyScheduleMap.inputRegEx.exec(this.schedule);
    let isPreformatted = !!(this.schedule && this.schedule.startsWith('!'));

    return {
      hasSchedule: !!(this.schedule),
      isPreformatted: isPreformatted,
      shouldParse: !!(parsedInput) && !isPreformatted,
      parsedInput: parsedInput
    };
  },
  methods: {
    getDayStrings(day) {
      if (!day) {
        return;
      }

      return constants.prettyScheduleMap.days[day];
    },
    /**
     * Parses out time components for better usability.
     *
     * @param time - expected format: 'HH:MM T' where T is AM or PM
     */
    parseTime(time) {
      if (!time) {
        return;
      }

      // split at space first to separate out meridiem (AM / PM)
      let spaceSplit = time.split(' ');

      if (!spaceSplit[1] || !constants.prettyScheduleMap[spaceSplit[1]]) {
        return;
      }

      // split at colon from first split
      let timeSplit = spaceSplit[0].split(':');
      if (!timeSplit[1]) {
        return;
      }

      return {
        h: timeSplit[0],
        m: timeSplit[1],
        meridiem: constants.prettyScheduleMap[spaceSplit[1]]
      };
    },
    /**
     * @param parsedInput - result of the regex applied to this.schedule; [full, day1, day2, time1, time2]
     */
    createSchedule(parsedInput) {
      let openingDay = this.getDayStrings(parsedInput[1]);
      let closingDay = this.getDayStrings(parsedInput[2]);
      let openingTime = this.parseTime(parsedInput[3]);
      let closingTime = this.parseTime(parsedInput[4]);

      // Return empty object if unable to form a complete schedule (day + times)
      if (!openingDay || !openingTime || !closingTime) {
        return {};
      }

      let longDay = `${openingDay[0]}${closingDay ? ` &ndash; ${closingDay[0]}` : ''}`;
      let longTime = `${openingTime.h}:${openingTime.m} ${openingTime.meridiem[0]} &ndash; ` +
        `${closingTime.h}:${closingTime.m} ${closingTime.meridiem[0]}`;

      let timezone = `${constants.prettyScheduleMap.timezone}`;

      return {
        long: `${longDay}, ${longTime} ${timezone}`
      };
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/shared/pretty-schedule.vue